import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import CommonInput from "../../components/input/CommonInput";

// api
import { requestResetPassword, verifyResetPassword } from "../../services/api/user";


const VERIFY_LIMIT_TIME = 60000;

function CheckEmailPage() {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [input, setInput] = useState({
        text: ""
    });

    // 타이머
    const timeRef = useRef(0);
    const [limitTime, setLimitTime] = useState(VERIFY_LIMIT_TIME);
    const [startTimer, setStartTimer] = useState(true);

    const handleInput = (value, type) => {
        setInput({
            [type]: value
        })
    }

    const handleClickVerifyButton = async (event) => {
        event.preventDefault();

        setInput({
            text: input.text.trim()
        })

        try{
            const data = {
                email: state,
                code: input.text.trim()
            };
            const res = await verifyResetPassword(data);
            navigate("/forgot-password/reset-password", { state });
        }catch(err){
            console.error(err);
            alert("Verify Code does not match")
        }        
    }

    const handleResendEmail = async (event) => {
        event.preventDefault();

        try{
            const res = await requestResetPassword(state);

            timeRef.current = VERIFY_LIMIT_TIME;
            setLimitTime(VERIFY_LIMIT_TIME);
            setStartTimer(true);

            alert("The code has been mailed back.");
            
        }catch(err){
            console.error(err);
            if(err.response && err.response.data.message) alert(err.response.data.message);
        }
    }

    const refreshPage = async () => {

        try{
            const res = await requestResetPassword(state);

            timeRef.current = VERIFY_LIMIT_TIME;
            setLimitTime(VERIFY_LIMIT_TIME);
            setStartTimer(true);

            alert("The code has been mailed back.");

        }catch(err){
            console.error(err);
            if(err.response && err.response.data.message) alert(err.response.data.message);
        }
    }

    useEffect(() => {

        window.addEventListener('pageshow', refreshPage);

        timeRef.current = VERIFY_LIMIT_TIME;
        setLimitTime(VERIFY_LIMIT_TIME);
        setStartTimer(true);

        return () => {
            window.removeEventListener('pageshow', refreshPage);
        }

    },[])

    useEffect(()=>{
        let interval;

        if(startTimer){            
            interval = setInterval(() => {
                timeRef.current -= 1000;
                setLimitTime(timeRef.current);
                if(timeRef.current===0){
                    clearInterval(interval);
                    setStartTimer(false)
                }
            },1000)
        }

        return () => {
            clearInterval(interval);
        }
    },[startTimer])

    
    return (
        <form className="CheckEmailPage">
            <div className="Title">
                Check your mail.
            </div>
            <div className="Description">
                <div>
                    We just sent an code
                </div>
                <div>
                    to your registered email address.
                </div>
            </div>
            <div className="Description2">
                Didn't get the email?&nbsp;
                <button type="button" onClick={handleResendEmail}>Resend the email</button>
            </div>
            <div className="Input">
                <CommonInput
                    type="text"
                    placeholder="Enter code."
                    handleInput={handleInput}
                    input={input}
                />
            </div>
            {limitTime===0 ? 
            <button
                type="submit"
                className="VerifyCodeButton"
                onClick={handleResendEmail}
            >
                Resend Email
            </button>
            : <button
                type="submit"
                className="VerifyCodeButton"
                onClick={handleClickVerifyButton}
                disabled={!input.text}
            >
                Verify Code
            </button>}
            <div className="Timer">{Math.floor(limitTime/60000)}:{(limitTime%60000/1000).toString().padStart(2, '0')}</div>
        </form>
    );
}

export default CheckEmailPage;